var __jsx = React.createElement;
import { BounceLoader } from 'react-spinners';
import { Typography, Spin, Progress } from 'antd';
import useSWR from 'swr';
import React from 'react';
import { useSelector } from 'react-redux';
import fetchAPI from 'utils/http/fetchAPI';
import colors from 'utils/styling/colors';
var Text = Typography.Text;
var spinnerStyles = "\n  .loader-spinner .ant-spin-dot-item {\n    background-color: ".concat(colors.darkRed, ";\n  }\n");
var slowLoad = function slowLoad() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 25
    }
  }, /*#__PURE__*/React.createElement("center", null, /*#__PURE__*/React.createElement(BounceLoader, {
    size: 50,
    color: "#8f0b10",
    css: {
      display: 'block'
    }
  }))), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Text, null, "This will take a few minutes...")), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Text, {
    type: "secondary"
  }, "We're setting up your analysis after a period of inactivity. Please wait.")));
};
var fastLoad = function fastLoad(message, percent) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("style", null, spinnerStyles), typeof percent === 'number' ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: 300,
      padding: 25
    }
  }, /*#__PURE__*/React.createElement(Progress, {
    percent: percent,
    status: "normal",
    strokeColor: colors.darkRed
  })) : /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 25
    }
  }, /*#__PURE__*/React.createElement(Spin, {
    size: "large",
    className: "loader-spinner"
  })), /*#__PURE__*/React.createElement("p", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Text, null, message || "We're getting your data ...")));
};
var Loader = function Loader(_ref) {
  var _backendStatus$experi;
  var experimentId = _ref.experimentId;
  var backendStatus = useSelector(function (state) {
    return state.backendStatus;
  });
  var workerInfo = backendStatus === null || backendStatus === void 0 || (_backendStatus$experi = backendStatus[experimentId]) === null || _backendStatus$experi === void 0 || (_backendStatus$experi = _backendStatus$experi.status) === null || _backendStatus$experi === void 0 ? void 0 : _backendStatus$experi.worker;
  var _useSWR = useSWR(function () {
      return experimentId ? "/v2/experiments/".concat(experimentId, "/backendStatus") : null;
    }, fetchAPI),
    workerStatus = _useSWR.data;
  if (!workerStatus) {
    return /*#__PURE__*/React.createElement("div", null, fastLoad('Assigning a worker to your analysis'));
  }
  if (workerInfo && workerInfo.userMessage) {
    var userMessage = workerInfo.userMessage,
      progressPercent = workerInfo.progressPercent;
    return /*#__PURE__*/React.createElement("div", null, fastLoad(userMessage, progressPercent));
  }
  var _workerStatus$worker = workerStatus.worker,
    started = _workerStatus$worker.started,
    ready = _workerStatus$worker.ready;
  if (started && ready) {
    return /*#__PURE__*/React.createElement("div", null, fastLoad('Assigning a worker to your analysis'));
  }
  return /*#__PURE__*/React.createElement("div", null, slowLoad());
};
export default Loader;
export { fastLoad, slowLoad };